var map = {
	"./1x1.svg": 25448,
	"./1x2.svg": 76187,
	"./2x2.svg": 352,
	"./add.svg": 83241,
	"./alert-bell.svg": 73612,
	"./alert.svg": 79954,
	"./angle.svg": 87865,
	"./area.svg": 81611,
	"./arrow-down.svg": 37280,
	"./arrow-left.svg": 93903,
	"./arrow-right.svg": 19146,
	"./arrow-top-left.svg": 85657,
	"./arrow-top-right.svg": 57316,
	"./arrow-up.svg": 74099,
	"./ascending.svg": 51334,
	"./bell-glyph.svg": 60006,
	"./bell.svg": 97963,
	"./bill-glyph-16.svg": 6078,
	"./bill.svg": 21183,
	"./both-eyes.svg": 6012,
	"./bpm.svg": 49423,
	"./building.svg": 60192,
	"./calendar.svg": 5194,
	"./cart.svg": 10626,
	"./chart-primary.svg": 57781,
	"./check-glyph.svg": 10917,
	"./check-square.svg": 21312,
	"./check.svg": 85536,
	"./chevron-down.svg": 59558,
	"./chevron-left.svg": 42797,
	"./chevron-right.svg": 64080,
	"./chevron-up.svg": 82781,
	"./circuit.svg": 38329,
	"./close.svg": 332,
	"./cloud-error-16.svg": 37338,
	"./cloud-error.svg": 74150,
	"./cog.svg": 66277,
	"./compare.svg": 12965,
	"./copy.svg": 90287,
	"./crossroad.svg": 98394,
	"./delete.svg": 58177,
	"./descending.svg": 71998,
	"./device.svg": 42862,
	"./directions.svg": 62250,
	"./download.svg": 15912,
	"./edit.svg": 4332,
	"./export.svg": 92122,
	"./eye-open.svg": 26856,
	"./filter.svg": 12454,
	"./group.svg": 78425,
	"./halt.svg": 69513,
	"./inadequate.svg": 9675,
	"./info-glyph-32.svg": 56009,
	"./info.svg": 9764,
	"./left-arrow.svg": 20071,
	"./left-eye.svg": 2083,
	"./lens-unavailable.svg": 44509,
	"./link.svg": 94120,
	"./list.svg": 50208,
	"./loader.svg": 89473,
	"./loading-spinner-large.svg": 97206,
	"./loading-spinner-small.svg": 4906,
	"./loading.svg": 41220,
	"./lock-2.svg": 35548,
	"./lock.svg": 34269,
	"./lungs.svg": 90139,
	"./maintenance.svg": 39949,
	"./minus.svg": 27200,
	"./more.svg": 99523,
	"./multidot.svg": 61128,
	"./myopia.svg": 7565,
	"./nhs-logo.svg": 7883,
	"./no-roles.svg": 78701,
	"./note.svg": 34260,
	"./offline-glyph-32.svg": 13066,
	"./order-history.svg": 66835,
	"./org-unit.svg": 80137,
	"./outcome.svg": 84892,
	"./pen.svg": 79977,
	"./pin.svg": 13669,
	"./play.svg": 24342,
	"./plus.svg": 2856,
	"./preferences1.svg": 42451,
	"./primary-vector.svg": 17514,
	"./private-labels.svg": 54483,
	"./product-arrow-down.svg": 42526,
	"./product-arrow-up.svg": 44629,
	"./refresh.svg": 10369,
	"./reload.svg": 24759,
	"./right-arrow.svg": 46338,
	"./right-eye.svg": 21622,
	"./right-vector-arrow.svg": 51034,
	"./search.svg": 77156,
	"./section.svg": 16893,
	"./signout.svg": 87553,
	"./sortable.svg": 46588,
	"./support.svg": 61389,
	"./text.svg": 62989,
	"./tick-2.svg": 38346,
	"./tick.svg": 52687,
	"./trash.svg": 10142,
	"./undo.svg": 99586,
	"./user-glyph-32.svg": 98894,
	"./user.svg": 50489,
	"./users-multiple.svg": 26537,
	"./warning.svg": 12644,
	"./workstation.svg": 1937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70012;